import { Cluster } from "@mapmycustomers/shared/types/map";

import colors from "@app/styles/_colors.module.scss";
import { BASE_CLUSTER_FILL_OPACITY } from "@app/util/map/consts";
import { BASE_CLUSTER_ZINDEX } from "@app/util/map/consts";
import getScaledSize from "@app/util/map/markerStyles/getScaledSize";
import getSvgForCluster from "@app/util/map/markerStyles/getSvgForCluster";
import svgToDataUrl from "@app/util/map/svgToDataUrl";

const CLUSTER_SIZE_THRESHOLD = 100;

const defaultClusterStyleGetter = (cluster: Pick<Cluster, "count">) => {
  const fillColor = cluster.count >= CLUSTER_SIZE_THRESHOLD ? colors.red010 : colors.yellow010;
  const strokeColor = cluster.count >= CLUSTER_SIZE_THRESHOLD ? colors.red100 : colors.yellow050;
  const scale = cluster.count >= CLUSTER_SIZE_THRESHOLD ? 0.8 : 0.5;
  const fontSize = cluster.count >= CLUSTER_SIZE_THRESHOLD ? 20 : 16;

  const { anchor, size, svg } = getSvgForCluster(fillColor, strokeColor);

  return {
    clickable: true,
    icon: {
      anchor: new google.maps.Point(...getScaledSize(anchor, scale)),
      scaledSize: new google.maps.Size(...getScaledSize(size, scale)),
      url: svgToDataUrl(svg),
    },
    label: {
      color: colors.slate,
      fontSize: `${fontSize}px`,
      text: String(cluster.count),
    },
    opacity: BASE_CLUSTER_FILL_OPACITY,
    // adjust zIndex to be above other markers
    zIndex: BASE_CLUSTER_ZINDEX + cluster.count,
  };
};

export default defaultClusterStyleGetter;
